import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import { createAction, createReducer } from 'redux-act';
var selectIsNavigationExpanded = function selectIsNavigationExpanded(state) {
  return state.layout.navigation.expanded;
};
var toggleNavigation = createAction('Toggle navigation visibility');
export var layout = {
  selectors: {
    selectIsNavigationExpanded: selectIsNavigationExpanded
  },
  actions: {
    toggleNavigation: toggleNavigation
  }
};
var initialState = {
  navigation: {
    expanded: false
  }
};

// The redux-act definitions aren't maintained and almost unusable.
// flowlint-next-line unclear-type: off
var reducer = createReducer(_defineProperty({}, toggleNavigation, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    navigation: {
      expanded: !state.navigation.expanded
    }
  });
}), initialState);
export default reducer;